module.exports = "/_next/static/images/GOER-Djimi-6728253a371df10e46023e685470dfc3.svg";